// import Swiper JS
import Swiper, {Autoplay, Pagination, HashNavigation, Navigation} from 'swiper/core';
// configure Swiper to use modules
Swiper.use([Pagination, Autoplay, HashNavigation, Navigation]);

import 'swiper/swiper-bundle.css';

class Testimonials {
    constructor() {
        this.init();
    }

    init() {
        const swiper = new Swiper(".testimonials-swiper", {
            slidesPerView: 1,
            loop: true,
            centeredSlides: true,
            spaceBetween: 15,
            navigation: {
                nextEl: ".swiper-nav-next",
                prevEl: ".swiper-nav-prev",
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter : false
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.5,
                },
                1200: {
                    slidesPerView: 3.7,
                },
                1600: {
                    slidesPerView: 4.1,
                },
            },
        });
    }
}

document.addEventListener("DOMContentLoaded", function (event) {
    new Testimonials();
});
